import { useSite } from "@/context/SiteContext";
import { mediaUrl } from "@/lib/api";
import { Reveal, SectionHead, Stars } from "@/components/Reveal";

export default function TestimonialsPage() {
  const { testimonials } = useSite();
  const list = testimonials || [];

  return (
    <div className="pt-24 sm:pt-28" data-testid="testimonials-page">
      <section className="relative py-14 sm:py-20 overflow-hidden">
        <div className="ambient-glow w-[560px] h-[300px] -top-32 right-0 opacity-40" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHead
            eyebrow="Client Directory"
            title="Every review, unfiltered"
            sub="Real words from real businesses — the reason we don't need to exaggerate."
          />
          {list.length === 0 ? (
            <p className="text-center text-sm text-subtle py-16" data-testid="testimonials-empty-state">No testimonials published yet.</p>
          ) : (
            <div className="columns-1 sm:columns-2 lg:columns-3 gap-6">
              {list.map((t, i) => (
                <Reveal key={t.id || i} delay={(i % 3) * 0.06} className="break-inside-avoid mb-6">
                  <div className="glass rounded-2xl p-6 sm:p-7 transition-all duration-500 hover:border-accent/35" data-testid={`testimonials-page-card-${i}`}>
                    <Stars rating={t.rating} className="mb-4" />
                    <p className="text-sm text-mist leading-relaxed mb-6">"{t.text}"</p>
                    <div className="flex items-center gap-3">
                      {t.avatar_url ? (
                        <img src={mediaUrl(t.avatar_url)} alt={t.name} loading="lazy" className="h-10 w-10 rounded-full object-cover border border-white/15" />
                      ) : (
                        <span className="h-10 w-10 rounded-full bg-accent/20 border border-accent/30 flex items-center justify-center text-xs font-bold text-accent-bright">
                          {(t.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("")}
                        </span>
                      )}
                      <div>
                        <p className="text-sm font-semibold text-white">{t.name}</p>
                        <p className="text-xs text-subtle">{[t.role, t.company].filter(Boolean).join(", ")}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
